import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationLocationPvConstants {
    static STEP_TITLE = "Location";
    static FIELD_CARD_PUBLIC_REPORT = "FieldCard Public Report";
    static FIELD_CARD_MUNICIPAL_REPORT = "FieldCard Valuer Report";
    static VIEW_BLOCK_AVERAGES_BUTTON_PLACEHOLDER = "View block averages";
    static RESET_BLOCK = "Reset block";
    static IMPORT_DATA = "Import parent attributes parameters?";
    static DELETE_PROPERTY_TITLE = "Delete property";
    static EDIT_PROPERTY_TITLE = "Edit property";
    static DELETE_PROPERTIES_CONFIRM = SharedConstants.REMOVE_MESSAGE + " Property(Properties)?";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static VALUATION_BLOCK_PROPERTIES = "valuationBlockProperties";
    static SALES_AREA_PROPERTIES = "salesAreaProperties";
    static VALUATION_BLOCK_SHAPE = "shape";
    static SALES_AREA_SHAPE = "salesAreaShape";
    static BLOCK_LAYER_NAME = "Valuation Block";
    static PROPERTY_LAYER_NAME = "Valuation Block Properties";
    static SELECTED_PROPERTY_LAYER_NAME = "Selected properties";
    static SALES_AREA_LAYER_NAME = "New sales areas";
    static NEW_VALUATION_BLOCK_LAYER_NAME = "valuationBlockProperties";
    static SALES_AREA_PROPERTY_NAME = "New sales areas properties";
    static NEW_VALUATION_BLOCK_PROPERTY_NAME = "New valuation block properties";
    static DRAW_TOOL_LAYER = "Draw Tool Layer";
    static BLOCK_CONSTANT = "block";
    static SALES_AREA_CONSTANT = "salesArea";
    static LOAD_VALUATION_BLOCK = "loadValuationBlock";
    static LOAD_SALES_AREA = "loadSalesArea";
    static RESHAPING_VALUATION_BLOCK = "reshapingValuationBlock";
    static DRAWING_SALES_AREA = "drawingSalesArea";
    static SKETCH_UPDATE_NOTIFICATION = "You need to select either Draw sales are or Draw valuation block option before you can proceed.";
    static ADD_BLOCK_SELECT_ACTION = "You need to select either Draw sales area or Draw valuation block option before you can proceed.";
    static ADD_BLOCK_WARNING = "You are not allowed to draw a new valuation block you can only reshape the existing one";
    static NO_POLYGONS_FOUND = "No properties found within the polygon drawn";
    static VALUATIONS_REJECTED = "Valuations has been rejected";
    static VALUATION_STATUS_ERROR = "An error occured while updating the valuation status.";
    static REDRAW_SUCCESS_NOTIFICATION = "Valuation block and sales area updated";
    static NO_EDITS = "No properties were edited";
    static PROPERTIES_IN_BLOCK_LABEL = "Properties in block:";
    static SG_CODE_EDIT = "sgCodeEdit";
    static ADDRESS_EDIT = "addressEdit";
    static OWNERS = "ownersEdit";
    static ERF_NO_EDIT = "erfNumberEdit";
    static FARM_NO = "farmNumberEdit";
    static ERF_SIZE_EDIT = "erfSizeEdit";
    static PORTION_NO = "portionNumberEdit";
    static RECIPIENTS = "recipients";
    static DATA_SOURCE = "dataSource";
    static EDIT_INDEX = "editIndex";
    static NO_CATEGORY_INFORMATION = "no category information";
    static PROPERTY_TYPES = "propertyTypes";
    static PROPERTY_TYPE = "PropertyType";
    static ZONING_ALTERNATE = "Zoning";
    static SALES_AREAD_SHAPE = "salesAreaShape";
    static TABLE_SELECTION = "tableSelection";
    static SHAPE = "shape";
    static WKID = "wkid";
    static ALLOTMENT = "allotment";
    static OBJECTION_ID = "objectionId";
    static ZONING = "zoning";
    static DELETED = "deleted";
    static SUBDIVISION = "subdivision";
    static IMPROVEMENT = "improvement";
    static DESCRIPTION = "description";
    static UNIT_NUMBER = "unitNumber";
    static ERF_NUMBER = "erfNumber";
    static ERF_SIZE = "erfSize";
    static FARM_NUMBER = "farmNumber";
    static ADDRESS = "address";
    static SG_CODE = "sgCode";
    static UNIT_NUBER = "unitNumber";
}
